module.exports = __webpack_public_path__ + "static/media/fbtb_photo_card.ad795dc4.jpeg";